import React__default from 'react';
import { AriaRole } from '../../../../../../types.mjs';
import styles from './Item.scss.mjs';

function Section({
  children
}) {
  return /*#__PURE__*/React__default.createElement("li", {
    role: AriaRole.Presentation,
    className: styles.Section
  }, children);
}

export { Section };
